import React from 'react';
import { PromptVariable, PromptVariableViewModel } from '../../types';
import { VariableRowCell } from './VariableRowCell';

export const VariableOfStringTypeFields = ({
  variable,
  onUpdate,
  hideNameValue,
}: {
  variable: PromptVariableViewModel;
  onUpdate: (newValue: PromptVariable) => void;
  hideNameValue?: boolean;
}) => {
  const onNameAdded = (newValue: string) => {
    if (variable.variableValue.type === 'string' && newValue !== variable.variableValue.name) {
      const updateValue: PromptVariable = {
        ...variable,
        variableValue: {
          ...variable.variableValue,
          value: newValue,
        },
      };
      onUpdate(updateValue);
    }
  };

  const onDescriptionAdded = (newValue: string) => {
    if (
      variable.variableValue.type === 'string' &&
      newValue !== variable.variableValue.description
    ) {
      const updateValue: PromptVariable = {
        ...variable,
        variableValue: {
          ...variable.variableValue,
          description: newValue,
        },
      };
      onUpdate(updateValue);
    }
  };

  if (variable.variableValue.type === 'string') {
    return (
      <>
        {!hideNameValue && (
          <>
            <div
              data-test="variables-table__string-name-row"
              className="variables-table__row variables-table__row--highlighted d-flex"
            >
              <div
                className="variables-table__string-variable-name-cell"
                style={{ maxWidth: '25%' }}
              >
                {variable.nameLabel || 'Name'}
              </div>
              <VariableRowCell
                origValue={variable.variableValue.value}
                placeholder={variable.namePlaceholder || 'Add name'}
                onUpdate={onNameAdded}
                style={{ maxWidth: '95%' }}
                textMaxLength={40}
              />
            </div>
            {variable.note && (
              <div className="variables-table__row d-flex">
                <div
                  className="variables-table__string-variable-name-cell"
                  style={{ maxWidth: '25%' }}
                />
                <div className="variables-table__note">{variable.note}</div>
              </div>
            )}
          </>
        )}
        {!variable.hideDescription && (
          <div
            data-test="variables-table__string-description-row"
            className="variables-table__row variables-table__row--highlighted d-flex"
          >
            <div className="variables-table__string-variable-name-cell" style={{ maxWidth: '25%' }}>
              {variable.descriptionLabel || 'Description'}
            </div>
            <VariableRowCell
              origValue={variable.variableValue.description}
              placeholder={variable.descriptionPlaceholder || 'Add description'}
              onUpdate={onDescriptionAdded}
              style={{ maxWidth: '95%' }}
              textMaxLength={300}
            />
          </div>
        )}
      </>
    );
  }

  return null;
};
